import { useState } from 'react';
import Page from '../components/Page';
import Container from '../components/Container';
import Input from '../components/Input';
import Button from '../components/Button';
import Error from './_error';
import { toast } from 'react-toastify';
import { saveUser, useConfig, useGetSubscription, useUser } from '@mm/common';
import Spinner from '../components/Spinner';
import { useApi } from '@mm/common';
import classNames from 'classnames';
import { CheckCircleIcon } from '@heroicons/react/24/solid';

export async function getStaticProps(context) {
  return {
    props: {},
  };
}

export default () => {
  const { data: user, isLoading } = useUser();

  if (isLoading)
    return (
      <Page title="Абонамент">
        <Spinner className="my-12" />
      </Page>
    );

  if (!user) {
    return <Error statusCode={404} />;
  }

  return <Subscription />;
};

function Subscription() {
  const api = useApi();
  const { data: user, mutate } = useUser();
  // const subscriptionQuery = useGetSubscription();
  const { data: config } = useConfig();

  if (!user || !config) return null;

  const plan = config.plans[user.subscription.planId];

  return (
    <Page title="Абонамент">
      <Container className="max-w-screen-md">
        <h1 className="text-2xl font-bold mb-6">Абонамент</h1>
        <div className="mt-4 py-6 w-full md:w-64">
          <div
            className={classNames(
              'bg-white rounded-xl space-y-6 overflow-hidden transition-all duration-500 transform hover:-translate-y-6 -translate-y-2 scale-105 shadow-xl hover:shadow-2xl',
              {
                // 'cursor-pointer': !isCurrentPlan,
                // 'shadow-2xl shadow-primary-200': isSelectedPlan,
              }
            )}
            onClick={async () => {
              // if (isCurrentPlan) return;
              // setSelectedPlan(plan);
            }}
          >
            <div className="py-4 px-2">
              <div className="px-8 flex justify-between items-center">
                <h4 className="text-xl font-semibold text-slate-500">{user.subscription.planId}</h4>
                <CheckCircleIcon className="inline-block h-6 fill-green-400" />
              </div>
              <h1 className="my-2 text-2xl text-center font-bold">
                {plan.amount > 0 ? `${plan.amount}лв. / месец` : 'Безплатен'}
              </h1>
              <ul className="text-center">
                <li>
                  <span className="text-slate-600">Запазени търсения: </span>
                  <span className="font-semibold">
                    {plan.terms || 'Неограничени'}
                  </span>
                </li>
                {plan.trialPeriod && (
                  <li>
                    <span className="text-slate-600">Безплатен период: </span>
                    <span className="font-semibold">
                      {plan.trialPeriod} дни
                    </span>
                  </li>
                )}
              </ul>
            </div>
            <Button
              className="block w-full rounded-t-none border-none"
              variant="link"
            >
              Спри
            </Button>
          </div>
        </div>
      </Container>
    </Page>
  );
}
